"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationProvider = exports.AuthenticationContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const authentication_service_1 = require("../authentication-service");
const oidc_events_1 = require("../oidc-events");
const callback_1 = require("./callback");
const oidc_routes_1 = require("./oidc-routes");
const session_lost_1 = require("./session-lost");
exports.AuthenticationContext = react_1.createContext(undefined);
const setDefaultState = (configuration) => ({
    userManager: authentication_service_1.authenticationService(configuration),
    isLoading: false,
});
const AuthenticationProvider = (props) => {
    const [oidcState, dispatch] = react_1.useReducer(oidc_events_1.oidcReducer, setDefaultState(props.configuration));
    react_1.useEffect(() => {
        dispatch({ type: 'ON_LOADING' });
        oidc_events_1.addOidcEvents({ customEvents: props.customEvents, dispatch, userManager: oidcState.userManager });
        oidcState.userManager.getUser().then((user) => {
            if (!user) {
                return;
            }
            dispatch({ type: 'ON_LOAD_USER', user });
        });
        return () => oidc_events_1.removeOidcEvents({ customEvents: props.customEvents, dispatch, userManager: oidcState.userManager });
    }, [oidcState.userManager, props.customEvents]);
    const { oidcUser, isLoading, error } = oidcState;
    const { authenticating, notAuthenticated, notAuthorized, callbackComponentOverride, sessionLost, configuration, children, history, } = props;
    const login = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return yield oidc_events_1.login(oidcState.userManager, dispatch, history.location, history)(); }), [
        history,
        oidcState.userManager,
    ]);
    return (react_1.default.createElement(exports.AuthenticationContext.Provider, { value: {
            isLoading,
            oidcUser,
            error,
            authenticating: authenticating === null || authenticating === void 0 ? void 0 : authenticating(),
            login,
            logout: react_1.useCallback(() => oidc_events_1.logout(oidcState.userManager, dispatch)(), [oidcState.userManager]),
        } },
        react_1.default.createElement(oidc_routes_1.OidcRoutes, { notAuthenticated: notAuthenticated === null || notAuthenticated === void 0 ? void 0 : notAuthenticated({ login }), notAuthorized: notAuthorized === null || notAuthorized === void 0 ? void 0 : notAuthorized(), callbackComponent: react_1.default.createElement(callback_1.CallbackContainer, { callbackComponentOverride: callbackComponentOverride === null || callbackComponentOverride === void 0 ? void 0 : callbackComponentOverride(), history: history }), sessionLost: react_1.default.createElement(session_lost_1.SessionLostContainer, { SessionLostComponentOverride: sessionLost, history: history }), configuration: configuration }, children)));
};
exports.AuthenticationProvider = AuthenticationProvider;
//# sourceMappingURL=authentication-provider.js.map